import email from "./images/email.png";
import facebook from "./images/facebook.png";

const list = [
    {
        id: 1,
        title: "Email",
        para: "thefidelfoundation@yahoo.com",
        img: email,
        link: "mailto:thefidelfoundation@yahoo.com"
    },
    {
        id: 2,
        title: "Facebook",
        para: "The Fidel Foundation",
        img: facebook,
        link: "https://www.facebook.com/The-Fidel-Foundation-116903573053259"
    }
];

export default list;